// extracted by mini-css-extract-plugin
export default {"root":"ValidationTimeMaskInput_root__WR53W","errorMessage":"ValidationTimeMaskInput_errorMessage__M9lpQ"};